<template>
  <div class="pt-3">
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <title-page
          title="List Assessment Report"
          :back="true"
          colorIconBack="#006341"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-if="permissions.includes('ASSESSMENT') || role === 'SUPERADMIN'"
      >
        <div class="d-flex justify-end">
          <v-btn
            class="bg_default text-capitalize mr-2"
            depressed
            dark
            @click="createReport"
            ><v-icon>mdi-plus-box-outline</v-icon> Manual</v-btn
          >
          <v-btn
            class="bg_default text-capitalize"
            depressed
            dark
            @click="selectPhase"
            ><v-icon>mdi-plus-box-multiple-outline</v-icon> Automatic</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <div class="d-flex justify-end mt-2">
      <v-menu v-model="menuReport" bottom :nudge-bottom="50" elevation="0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            class="text-capitalize color_txt"
            height="38px"
            color="#fff"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </template>
        <v-card class="popup_radius" outlined elevation="0">
          <v-list>
            <v-list-item link to="/report/download-counter">
              <v-list-item-title>Downloaded Report</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/admin/cm/download/batch/teladan-report">
              <v-list-item-title>Archived Report</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </div>
    <!--  ========================================================================= toolbar -->

    <v-card class="rounded_max mt-5 mb-3" flat>
      <div class="pa-3">
        <v-card flat class="rounded-lg" color="#edf1f0">
          <v-row no-gutters>
            <v-col cols="12" md="3">
              <div class="pa-2">
                <v-text-field
                  placeholder="Search User"
                  solo
                  v-model="find"
                  @keyup="onSearch"
                  @click:clear="onClearSeach"
                  hide-details
                  dense
                  prepend-inner-icon="mdi-magnify"
                  flat
                  clearable
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2" v-if="!bulkAct">
                <v-select
                  dense
                  hide-details
                  :items="listPhase"
                  item-text="state"
                  item-value="abbr"
                  v-model="phase"
                  @change="onFilterPhase()"
                  placeholder="Filter Phase"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2" v-if="!bulkAct">
                <v-select
                  dense
                  hide-details
                  :items="getYear"
                  item-text="state"
                  item-value="abbr"
                  v-model="year"
                  @change="onFilterCohort()"
                  placeholder="Filter Phase"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2" v-if="!bulkAct">
                <v-btn
                  class="text-capitalize"
                  height="38px"
                  depressed
                  color="#fff"
                  block
                  @click="selectColumn"
                >
                  <v-icon class="mr-1" color="orange">mdi-filter-menu</v-icon>
                  Filter Column
                </v-btn>
              </div>
              <div
                class="pa-2"
                v-if="
                  (permissions.includes('ASSESSMENT') ||
                    role == 'SUPERADMIN') &&
                  bulkAct
                "
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      dark
                      v-bind="attrs"
                      v-on="on"
                      color="green"
                      height="38px"
                      depressed
                      class="text-capitalize"
                      @click="bulkAction('load')"
                      ><v-icon class="mr-1">mdi-progress-download</v-icon>
                      Download</v-btn
                    >
                  </template>
                  <span>Download reports in bulk</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2" v-if="!bulkAct">
                <v-btn
                  class="text-capitalize"
                  height="38px"
                  depressed
                  color="#fff"
                  block
                  @click="exportData"
                >
                  <v-icon class="mr-1" color="green"
                    >mdi-microsoft-excel</v-icon
                  >
                  Export Data
                </v-btn>
              </div>
              <div
                class="pa-2"
                v-if="
                  (permissions.includes('ASSESSMENT') ||
                    role === 'SUPERADMIN') &&
                  bulkAct
                "
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      dark
                      v-bind="attrs"
                      v-on="on"
                      color="red"
                      depressed
                      class="text-capitalize"
                      height="38px"
                      @click="bulkAction('del')"
                      ><v-icon class="mr-1">mdi-delete</v-icon> Delete</v-btn
                    >
                  </template>
                  <span>Delete reports in bulk</span>
                </v-tooltip>
              </div>
              <!-- <div
                class="pa-2"
                v-if="
                  (!permissions.includes('ASSESSMENT') ||
                    !role === 'SUPERADMIN') &&
                  bulkAct
                "
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      block
                      dark
                      v-bind="attrs"
                      v-on="on"
                      color="green"
                      height="38px"
                      depressed
                      class="text-capitalize"
                      @click="bulkAction('load')"
                      ><v-icon class="mr-1">mdi-progress-download</v-icon>
                      Download</v-btn
                    >
                  </template>
                  <span>Download reports in bulk</span>
                </v-tooltip>
              </div> -->
            </v-col>
            <v-col cols="12" md="1">
              <div class="pa-2">
                <v-tooltip top v-if="!bulkAct">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="text-capitalize"
                      height="38px"
                      depressed
                      color="#fff"
                      block
                      @click="bulkAct = true"
                    >
                      <v-icon color="blue"
                        >mdi-checkbox-multiple-marked-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Bulk Action</span>
                </v-tooltip>
                <v-btn
                  v-else
                  class="text-capitalize"
                  height="38px"
                  depressed
                  color="#fff"
                  block
                  dark
                  @click="bulkAct = false"
                >
                  <v-icon color="red">mdi-close-circle-outline</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <!--  ========================================================================= data table -->
      <div>
        <v-skeleton-loader
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :show-select="bulkAct"
            v-model="storage_id"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
          >
            <template v-slot:[`item.no`]="{ item }">
              {{
                dataSet
                  .map((x) => {
                    return x.id;
                  })
                  .indexOf(item.id) +
                1 +
                (page - 1) * limit
              }}
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <router-link class="opener_name" :to="`/scholar/${item.user_id}`">
                <p class="mb-0 black--text">{{ item.name }}</p>
              </router-link>
            </template>
            <template v-slot:[`item.period`]="{ item }">
              <div class="d-flex">
                <v-btn rounded color="green lighten-5" depressed>
                  <p class="ma-0 green--text text-capitalize">
                    {{ item.period }}
                  </p>
                </v-btn>
              </div>
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              <div class="d-flex">
                {{ $date(item.updated_at).format("DD MMMM YYYY") }}
              </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-btn small depressed color="blue" dark @click="toView(item)">
                  <v-icon dark small> mdi-eye-settings </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
    <v-menu v-model="menuLimit" bottom :nudge-bottom="55" elevation="0">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          class="text-capitalize color_txt"
          height="38px"
          color="#fff"
          v-bind="attrs"
          v-on="on"
          ><p class="default_txt">Show : {{ limit }}</p>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-card class="popup_radius" outlined elevation="0">
        <v-list>
          <v-list-item link @click="changeLimit(10)">
            <v-list-item-title>10</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="changeLimit(50)">
            <v-list-item-title>50</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="changeLimit(100)">
            <v-list-item-title>100</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <div class="my-3" v-if="dataSet">
      <v-pagination
        v-model="page"
        color="#006341"
        @input="onChangePage"
        :length="last_page"
      ></v-pagination>
    </div>
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
        @saveColumn="mutateColumn"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <select-phase-report
        :d_phase="d_phase"
        @refetch="fetchData"
        @close="d_phase = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <bulk-action-report
        :d_bulk_act="d_bulk_act"
        :inventory="inventory"
        @close="d_bulk_act = false"
        @refetch="fetchData"
        @selectType="d_generate_report = true"
      />
      <select-type-generate-report
        :d_generate_report="d_generate_report"
        :inventory="inventory"
        @close="d_generate_report = false"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitlePage from "../../../components/atom/titlePage.vue";
import DialogSmall from "../../dialog/dialogSmall.vue";
import BulkActionReport from "../report/bulk/bulkActionReport.vue";
import SelectTypeGenerateReport from "../report/bulk/selectTypeGenerateReport.vue";
import SelectPhaseReport from "./selectPhaseReport.vue";

export default {
  name: "listReport",

  components: {
    // dialogCreate,
    TitlePage,
    DialogSmall,
    // DialogLarge,
    SelectPhaseReport,
    BulkActionReport,
    SelectTypeGenerateReport,
  },

  computed: {
    ...mapState({
      chaceColumn: (state) => state.report.cachedColumn,
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
    getYear() {
      let data = [];
      let year = parseInt(this.$date().format("YYYY"));
      for (let i = 2019; i <= year; i++) {
        data.push({
          state: i,
          abbr: i,
        });
      }
      data.push({
        state: "All Cohort",
        abbr: "",
      });
      return data;
    },
  },
  data() {
    return {
      loading: false,
      d_small: false,
      inventory: null,
      d_create: false,
      d_phase: false,
      d_large: false,
      d_type: "",
      d_title: "",
      typeBulk: "",
      d_bulk_act: false,
      d_generate_report: false,
      storage_id: [],
      bulkAct: false,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      status: "",
      year: "",
      phase: "",
      optStatus: [
        { txt: "Active", val: 1 },
        { txt: "No Active", val: 0 },
        { txt: "All", val: "" },
      ],
      listPhase: [
        { state: "BASELINE", abbr: "baseline" },
        { state: "MIDLINE", abbr: "midline" },
        { state: "ENDLINE", abbr: "endline" },
        { state: "ALL PHASE", abbr: "" },
      ],
      headers: [
        {
          text: "NO",
          align: "start",
          sortable: false,
          value: "no",
        },
        {
          text: "TELADAN ID",
          align: "start",
          sortable: false,
          value: "no_tf",
        },

        {
          text: "FULL NAME",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "UNIVERSITY",
          align: "start",
          sortable: false,
          value: "university",
        },
        {
          text: "MAJOR",
          align: "start",
          sortable: false,
          value: "major",
        },
        {
          text: "PHASE",
          sortable: false,
          value: "period",
        },
        {
          text: "UPDATED BY",
          sortable: false,
          value: "updated_by",
        },
        {
          text: "DATE MODIFIED",
          sortable: false,
          value: "updated_at",
        },
        {
          text: "VIEW",
          sortable: false,
          value: "actions",
        },
      ],

      menuLimit: false,
      menuReport: false,
    };
  },
  mounted() {
    if (this.chaceColumn) {
      this.headers = this.chaceColumn;
    }
    this.getQueryParam();
  },

  methods: {
    getQueryParam() {
      const query = this.$route.query;
      this.find = query?.find ?? "";
      this.phase = query?.phase ?? "";
      this.year = query?.cohort ? parseInt(query?.cohort) : "";
      this.page = query?.page ? parseInt(query?.page) : 1;
      this.fetchData();
    },
    onClearSeach() {
      this.find = ""
      this.onSearch()
    },
    onSearch() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          find: this.find == null ? "" : this.find,
        },
      });
      this.onRefetch();
    },
    onFilterPhase() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          phase: this.phase,
        },
      });
      this.onRefetch();
    },
    onFilterCohort() {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          cohort: this.year,
        },
      });
      this.onRefetch();
    },
    onRefetch() {
      this.page = 1;
      this.fetchData();
    },
    onChangePage(page) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page,
        },
      });

      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `migrations/report_summary?include=dataScholar,dataUpdated&tahun_tf=${this.year}&filter[period]=${this.phase}&filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },

    mutateColumn() {
      this.headers = this.chaceColumn;
    },
    createReport() {
      this.d_type = "tocreatereport";
      this.d_title = "Select Scholar";
      this.d_create = true;
    },
    selectColumn() {
      this.d_type = "vcol_report";
      this.d_title = "Select column to be displayed";
      this.d_create = true;
    },
    exportData() {
      this.inventory = "report";
      this.d_type = "x_report";
      this.d_title = "Export Report";
      this.d_large = true;
    },
    toView(item) {
      this.inventory = item;
      this.d_type = "v_report";
      this.d_title = "";
      this.d_create = true;
    },
    selectPhase() {
      this.inventory = {
        gender: "gay",
        type: "automatic",
      };
      this.d_title = "";
      this.d_phase = true;
    },
    bulkAction(type) {
      let justId = [];
      if (type == "del") {
        justId = this.storage_id.map((el) => {
          return el.id;
        });
      } else {
        justId = this.storage_id.map((el) => {
          return el.scholar_id;
        });
      }

      this.inventory = {
        id: justId,
        type: type,
        path: "migrations/report_summary/delete",
      };
      this.d_bulk_act = true;
    },

    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },

    row_classes(item) {
      let idx = this.dataSet.indexOf(item);
      if (idx % 2 == 0) {
        return "strip_table"; //can also return multiple classes e.g ["orange","disabled"]
      }
    },
  },
};
</script>

<style>
.v-pagination__item {
  box-shadow: none !important;
}
.v-pagination__navigation {
  box-shadow: none !important;
}
</style>
